// @ts-check

if (!customElements.get("ff-slider-progress")) {
  class FfSliderProgress extends HTMLElement {
    ffStartPercentage = 0;
    ffEndPercentage = 0;

    constructor() {
      super();
      /**
       * @type {HTMLElement | null}
       */
      this.ffProgressBarEL = this.querySelector("[ff-progress-bar]");
    }

    ffAnimate(ffEndPercentage) {
      this.ffEndPercentage = ffEndPercentage;

      if (this.ffAnimationId) {
        cancelAnimationFrame(this.ffAnimationId);
      }

      this.ffRequestAnimationFrame();
    }

    ffRequestAnimationFrame() {
      this.ffAnimationId = requestAnimationFrame(() => {
        if (this.ffStartPercentage > this.ffEndPercentage) {
          this.ffStartPercentage = this.ffStartPercentage - 2;
          if (this.ffStartPercentage > this.ffEndPercentage) {
            this.ffRequestAnimationFrame();
          }
        } else if (this.ffStartPercentage < this.ffEndPercentage) {
          this.ffStartPercentage = this.ffStartPercentage + 2;
          if (this.ffStartPercentage < this.ffEndPercentage) {
            this.ffRequestAnimationFrame();
          }
        }

        this.ffProgressBarEL?.style.setProperty(
          "--ff-slider-progress-status-width",
          this.ffStartPercentage + "%"
        );
      });
    }
  }

  customElements.define("ff-slider-progress", FfSliderProgress);
}
